
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/customization/dark-mode",
      function () {
        return require("private-next-pages/material-ui/customization/dark-mode.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/customization/dark-mode"])
      });
    }
  